import { render, staticRenderFns } from "./companyOverview.vue?vue&type=template&id=22c4dbe2&scoped=true&"
import script from "./companyOverview.vue?vue&type=script&lang=js&"
export * from "./companyOverview.vue?vue&type=script&lang=js&"
import style0 from "./companyOverview.vue?vue&type=style&index=0&id=22c4dbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4dbe2",
  null
  
)

export default component.exports